<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ix"></a><a id="fm02"></a>And do you wonder<br/>about your place under the huge<br/>invisibly starry sky …</p>
<p class="center1">as I do mine?<br/>—Margaret Avison, “Relating”</p>
<p class="noindent"><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?b6f7cafc